export const environment = {
  production: true,
  api_url: 'https://api.hirelogic.co.uk/',
  app_url: 'https://app.hirelogic.co.uk',
  signature_socket_server: 'wss://api.hirelogic.co.uk/websocket',
  stripe_client_id: 'ca_EQ1Hc8saF0Jav6HKg0wkv0x9vkuvXKlj',
  name: 'production',
  stripe_publishable_key: 'pk_live_FvEsDvd0VkM3CwEIFuhhSshd'
};
